import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import FeedbackHeader from "./FeedbackHeader";

class FeedbackLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.capitalizeFirstLetter.bind(this);
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidMount() {
    let currentage = this.capitalizeFirstLetter(this.props.location.pathname);

    document.title = currentage + " | HireNeuron";
  }
  render() {
    return (
      <React.Fragment>
        <FeedbackHeader />
        {this.props.children}
      </React.Fragment>
    );
  }
}

FeedbackLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
};

export default withRouter(FeedbackLayout);
